import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import Legends from "../../../../components/legends/Legends";
import NoData from "../../../../components/noData/Nodata";
import TileBox from "../../../../components/tile/TileBox";
import { capitalizeWords } from "../../../../utils/helpers";

const ProvisionCount = ({ data }) => {
  const theme = useTheme();
  const { primary, secondary, warning, info, success } = theme.palette;
  const isEmpty = Boolean(!Object.keys(data).length);
  const keys = isEmpty ? [] : Object.keys(data);
  const colors = [
    primary.main,
    secondary.main,
    warning.main,
    info.main,
    success.main,
  ];

  const graphData = isEmpty
    ? null
    : keys.map((key, index) => {
        return {
          name: capitalizeWords(key),
          count: data[key],
          fill: colors[index],
        };
      });

  return (
    <TileBox title="Provision Count">
      <Box width={"100%"} height={"300px"}>
        {graphData ? (
          <>
            <ResponsiveContainer width="100%" height="90%">
              <BarChart
                barCategoryGap={14}
                data={graphData}
                margin={{ top: 20, right: 10, left: -10, bottom: 10 }}
              >
                <YAxis
                  axisLine={{ stroke: theme.palette.grey[300] }}
                  tickLine={false}
                  allowDecimals={false}
                />
                <XAxis
                  dataKey="name"
                  tickLine={false}
                  width={30}
                  interval={0}
                />
                <Bar
                  label={{ position: "top" }}
                  barSize={50}
                  dataKey="count"
                  radius={[4, 4, 0, 0]}
                >
                  {graphData.map((entry, index) => (
                    <Cell key={`code-report-${index}`} fill={entry.fill} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            <Legends sx={{ display: "flex" }} legends={graphData} />
          </>
        ) : (
          <NoData />
        )}
      </Box>
    </TileBox>
  );
};

export default ProvisionCount;
